import React from 'react'
import styled from 'styled-components'

import { CloseIcon, Fitty, Typography } from '@blade/ui-kit'

import type { ClassNameProps } from '@root/shared/react'

type Props = {
  title: React.ReactNode
  bigTitle: string
  onClose?: () => void
} & ClassNameProps

export const AnnouncementHeader = ({
  title,
  bigTitle,
  onClose,
  className,
}: Props) => {
  return (
    <Header className={className}>
      <GlowingRed />
      <Intro>{title}</Intro>
      <IntroMessageContainer>
        <IntroMessage multiLine={false} maxSize={62} minSize={10}>
          {bigTitle}
        </IntroMessage>
      </IntroMessageContainer>
      <HeaderGradient />
      <CloseButton size={20} onClick={onClose} />
    </Header>
  )
}

const Header = styled.div`
  height: 104px;
  background: var(--appearance-1);
  position: relative;
  overflow: hidden;

  display: grid;
  grid-template-columns: minmax(0, 1fr);
`

const HeaderGradient = styled.div`
  background: linear-gradient(0deg, var(--appearanceA-7) 30%, transparent 100%);
  position: absolute;
  bottom: 0;
  left: 0;
  top: 60px;
  width: 100%;
`

const GlowingRed = styled.span`
  background-image: radial-gradient(
    240px 150px at 50% -30px,
    var(--errorAccent-9) 50%,
    transparent 130%
  );
  position: absolute;
  width: 100%;
  height: 100px;
  left: 0;
  top: 0;
  opacity: 0.5;
`

const Intro = styled(Typography).attrs({
  variant: 'body5-bold',
  component: 'span',
})`
  text-align: center;

  font-weight: 900;
  letter-spacing: 0.66px;
  text-transform: uppercase;

  background: linear-gradient(180deg, var(--textA-7) 0%, var(--textA-5) 100%);
  text-transform: uppercase;
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;

  position: relative;
  margin-top: 20px;
  margin-bottom: 2px;
`

const IntroMessage = styled(Fitty)`
  text-align: center;
  text-shadow: 0px 0 0px var(--backgroundA-6);
  font-style: normal;
  font-weight: 700;

  background: linear-gradient(
    180deg,
    var(--backgroundA-5) 0%,
    transparent 98.63%,
    transparent 115.56%
  );

  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;

  position: relative;
  opacity: 0.4;

  text-transform: uppercase;
`

const CloseButton = styled(CloseIcon)`
  color: var(--textA-9);
  right: 15px;
  top: 15px;

  position: absolute;
  cursor: pointer;
  transition: color 0.2s ease-in-out;

  &:hover {
    color: var(--text-11);
  }
`

const IntroMessageContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-inline: 16px;
`
